import { render, staticRenderFns } from "./KycActivity.vue?vue&type=template&id=071e4d70&scoped=true&"
import script from "./KycActivity.vue?vue&type=script&lang=js&"
export * from "./KycActivity.vue?vue&type=script&lang=js&"
import style0 from "./KycActivity.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../assets/style/base.css?vue&type=style&index=1&id=071e4d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e4d70",
  null
  
)

export default component.exports